(function () {
  'use strict';

  function initFooter(container) {
    // Nothing to initialize — Shopify's customer form handles submission natively.
    // This hook exists for future enhancements (e.g. inline validation, analytics).
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.dataset.sectionType !== 'wm-footer') return;
    initFooter(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.dataset.sectionType !== 'wm-footer') return;
  });
})();
